/** Priority order: lower numeric value = higher priority when multiple sources are dirty. */
export enum UnsavedChangesScopeEnum {
  Modal = 1,
  Drawer = 2,
  Panel = 3,
  Settings = 4,
  Page = 5,
  App = 6,
}

export const UNSAVED_CHANGES_SCOPE_PRIORITY: Record<UnsavedChangesScopeEnum, number> = {
  [UnsavedChangesScopeEnum.Modal]: 1,
  [UnsavedChangesScopeEnum.Drawer]: 2,
  [UnsavedChangesScopeEnum.Panel]: 3,
  [UnsavedChangesScopeEnum.Settings]: 4,
  [UnsavedChangesScopeEnum.Page]: 5,
  [UnsavedChangesScopeEnum.App]: 6,
};
